import styled from "styled-components";

export const PageSection = styled.div`
  display: block;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const FilterLabel = styled.label`
  color: #cccccc;
  font-weight: 500;
  font-size: 0.9rem;
`;
export const Relative = styled.div`
  position: relative;
`;

export const FilterSelect = styled.select`
  padding: 0.6rem 1rem;
  border: 2px solid #333333;
  border-radius: 8px;
  background: #1a1a1a;
  color: #cccccc;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }

  &:hover {
    border-color: #555555;
  }

  option {
    background: #1a1a1a;
    color: #cccccc;
  }
`;

export const PageTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.8rem;
  font-weight: bold;
`;

export const Button = styled.button`
  padding: 0.8rem 1.2rem;
  min-height: 3rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: ${(props) => {
    switch (props.$variant) {
      case "primary":
        return "#ff6b35";
      case "secondary":
        return "#666";
      case "danger":
        return "#e74c3c";
      case "success":
        return "#27ae60";
      default:
        return "#ff6b35";
    }
  }};
  color: #ffffff;

  &:hover {
    background: ${(props) => {
      switch (props.$variant) {
        case "primary":
          return "#e55a2b";
        case "secondary":
          return "#555";
        case "danger":
          return "#c0392b";
        case "success":
          return "#229954";
        default:
          return "#e55a2b";
      }
    }};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ActionButtonGroup = styled.div`
  display: flex;
  margin-left: auto;
  justify-content: flex-end;
  gap: 0.5rem;
  /* flex-wrap: wrap; */
`;

export const TableContainer = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 1.5rem;
  border: 1px solid #333;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  td {
    min-width: 10rem;
    white-space: nowrap;
  }
`;

export const TableHeader = styled.th`
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #333;
  color: #ff6b35;
  font-weight: bold;
  background: rgba(255, 107, 53, 0.1);

  &:last-child {
    text-align: right;
  }

  &:first-child {
    text-align: left;
  }
`;

export const TableCell = styled.td`
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #333;
  color: #cccccc;

  &:first-child {
    text-align: left;
  }

  &:last-child {
    text-align: right;
  }
`;

export const TableRow = styled.tr`
  &:hover {
    background: rgba(255, 107, 53, 0.05);
  }
`;

export const StatusBadge = styled.button`
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;

  color: ${(props) => {
    switch (props.$status) {
      case "delivered":
      case "active":
        return "#27ae60";
      case "processing":
        return "#f39c12";
      case "inactive":
      case "canceled":
        return "#e74c3c";
      case "shipped":
        return "#3498db";
      case "pending":
        return "#f39c12";
      default:
        return "#cccccc";
    }
  }};
  background: ${(props) => {
    switch (props.$status) {
      case "delivered":
      case "active":
        return "rgba(39, 174, 96, 0.2)";
      case "processing":
      case "pending":
        return "rgba(243, 156, 18, 0.2)";
      case "inactive":
      case "canceled":
        return "rgba(231, 76, 60, 0.2)";
      case "shipped":
        return "rgba(52, 152, 219, 0.2)";
      default:
        return "rgba(204, 204, 204, 0.2)";
    }
  }};

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    opacity: 0.9;
  }

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #333;
  flex-wrap: wrap;
  gap: 1rem;

  & > div {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
`;

export const PaginationInfo = styled.span`
  color: #cccccc;
  font-size: 0.9rem;
`;

export const PaginationButton = styled.button`
  background: ${(props) => (props.$active ? "#ff6b35" : "#333")};
  color: ${(props) => (props.$active ? "#ffffff" : "#cccccc")};
  border: 1px solid ${(props) => (props.$active ? "#ff6b35" : "#555")};
  padding: 0.5rem 0.8rem;
  min-width: 40px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: ${(props) => (props.$active ? "bold" : "normal")};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: ${(props) => (props.$active ? "#e55a2b" : "#444")};
    border-color: ${(props) => (props.$active ? "#e55a2b" : "#666")};
    color: #ffffff;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background: #333;
    border-color: #555;
    color: #666;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Modal = styled.div`
  display: ${(props) => (props.$active ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  backdrop-filter: blur(5px);
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 2rem;
  max-width: 800px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  border: 2px solid #ff6b35;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const ModalTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.5rem;
  font-weight: bold;
`;

export const ModalClose = styled.button`
  background: none;
  border: none;
  color: #ff6b35;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  &:hover {
    transform: rotate(90deg);
  }
`;

export const CustomerInfoContainer = styled.div`
  margin-bottom: 2rem;
  padding: 1rem;
  background: #333;
  border-radius: 8px;
`;

export const CustomerInfoTitle = styled.h4`
  color: #ff6b35;
  margin-bottom: 1rem;
`;

export const CustomerInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
`;

export const CustomerInfoItem = styled.div``;

export const CustomerInfoLabel = styled.strong`
  color: #ff6b35;
  display: block;
`;

export const CustomerInfoValue = styled.span`
  color: ${(props) => (props.$total ? "#ffffff" : "#cccccc")};
  font-size: ${(props) => (props.$total ? "1.5rem" : "inherit")};
  font-weight: ${(props) => (props.$total ? "bold" : "normal")};
`;

export const OrderItemsContainer = styled.div`
  margin-bottom: 2rem;
  overflow: auto;
`;

export const OrderItemsTitle = styled.h4`
  color: #ff6b35;
  margin-bottom: 1rem;
`;

export const OrderSummaryContainer = styled.div`
  padding: 1rem;
  background: #333;
  border-radius: 8px;
  margin-bottom: 1rem;
`;

export const OrderSummaryGrid = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const OrderSummaryItem = styled.div`
  text-align: ${(props) => (props.$total ? "right" : "left")};
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
`;

export const StatusChangeModal = styled.div`
  display: ${(props) => (props.$active ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2100;
  backdrop-filter: blur(5px);
  align-items: center;
  justify-content: center;
`;

export const StatusChangeContent = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  border: 2px solid #ff6b35;
`;

export const StatusChangeTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.2rem;
  font-weight: bold;
`;

export const StatusOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StatusOption = styled.button`
  padding: 0.8rem 1rem;
  border-radius: 8px;
  border: 2px solid transparent;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  color: ${(props) => {
    switch (props.$status) {
      case "delivered":
      case "active":
        return "#27ae60";
      case "processing":
        return "#f39c12";
      case "inactive":
      case "canceled":
        return "#e74c3c";
      case "shipped":
        return "#3498db";
      case "pending":
        return "#f39c12";
      default:
        return "#cccccc";
    }
  }};
  background: ${(props) => {
    switch (props.$status) {
      case "delivered":
      case "active":
        return "rgba(39, 174, 96, 0.1)";
      case "processing":
      case "pending":
        return "rgba(243, 156, 18, 0.1)";
      case "inactive":
      case "canceled":
        return "rgba(231, 76, 60, 0.1)";
      case "shipped":
        return "rgba(52, 152, 219, 0.1)";
      default:
        return "rgba(204, 204, 204, 0.1)";
    }
  }};

  &:hover {
    border-color: ${(props) => {
      switch (props.$status) {
        case "delivered":
        case "active":
          return "#27ae60";
        case "processing":
        case "pending":
          return "#f39c12";
        case "inactive":
        case "canceled":
          return "#e74c3c";
        case "shipped":
          return "#3498db";
        default:
          return "#cccccc";
      }
    }};
    transform: translateX(5px);
  }
`;

// Confirm modal
export const ConfirmModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .modal-content {
    background: #2a2a2a;
    padding: 2rem;
    border-radius: 8px;
    border: 1px solid #444;
    max-width: 500px;
    width: 90%;
    text-align: center;

    h3 {
      color: #fff;
      margin-bottom: 1rem;
      font-size: 1.3rem;
    }

    p {
      color: #ccc;
      margin-bottom: 2rem;
      line-height: 1.5;

      strong {
        color: #ff6b35;
      }
    }

    .modal-actions {
      display: flex;
      gap: 1rem;
      justify-content: center;
    }
  }
`;
